module.exports = __webpack_public_path__ + "img/undraw_settings_tab_mgiw.37da807a.svg";